import { cn } from '../lib/cn'

type Kind = 'doc' | 'pdf' | 'xls' | 'img' | 'other'

function kindOf(name: string): { kind: Kind; label: string } {
  const ext = name.split('.').pop()?.toLowerCase() ?? ''
  if (ext.startsWith('doc')) return { kind: 'doc', label: 'DOC' }
  if (ext === 'pdf') return { kind: 'pdf', label: 'PDF' }
  if (ext.startsWith('xls')) return { kind: 'xls', label: 'XLS' }
  if (['png', 'jpg', 'jpeg', 'gif', 'webp'].includes(ext)) return { kind: 'img', label: 'IMG' }
  return { kind: 'other', label: (ext || 'file').slice(0, 3).toUpperCase() }
}

const BG: Record<Kind, string> = {
  doc: 'bg-blue-600',
  pdf: 'bg-red-600',
  xls: 'bg-green-600',
  img: 'bg-purple-600',
  other: 'bg-neutral-400',
}

export function FileTypeIcon({ name, className }: { name: string; className?: string }) {
  const { kind, label } = kindOf(name)
  return (
    <span
      className={cn(
        'flex h-9 w-9 shrink-0 items-center justify-center rounded-md text-[10px] font-bold text-white',
        BG[kind],
        className,
      )}
    >
      {label}
    </span>
  )
}
